import type { RelatieStatRomanData } from "@/types/entity";

const MSG_SELECT = "Selectează o opțiune";
const MSG_REQ = "Acest câmp este obligatoriu";

const REQUIRED_BOOLEAN_FIELDS: Array<keyof RelatieStatRomanData> = [
  "stabilita_in_romania",
  "sediu_principal_in_romania",
  "entitate_administratie_publica",
  "entitate_critica_294_2024",
  "entitate_extra_ue",
];

export function isRelatieStatComplete(
  data: RelatieStatRomanData | null | undefined
): boolean {
  for (const field of REQUIRED_BOOLEAN_FIELDS) {
    if (data?.[field] == null) return false;
  }
  if (data?.entitate_extra_ue === true) {
    const rep = data.reprezentant_romania;
    if (!rep?.denumire?.trim() || !rep?.adresa?.trim()) return false;
  }
  return true;
}

export function validateRelatieStatRoman(
  data: RelatieStatRomanData | null | undefined
): Record<string, string> {
  const errors: Record<string, string> = {};

  for (const field of REQUIRED_BOOLEAN_FIELDS) {
    if (data?.[field] == null) {
      errors[`relatie_stat_roman.${field}`] = MSG_SELECT;
    }
  }

  if (data?.entitate_extra_ue === true) {
    const rep = data.reprezentant_romania;
    if (!rep || !rep.denumire.trim()) {
      errors["relatie_stat_roman.reprezentant_romania.denumire"] = MSG_REQ;
    }
    if (!rep || !rep.adresa.trim()) {
      errors["relatie_stat_roman.reprezentant_romania.adresa"] = MSG_REQ;
    }
  }

  return errors;
}
